var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._g(_vm._b({attrs:{"outlined":"","hide-details":"auto","type":"number","min":"0"},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'v-text-field',{ ..._vm.input, ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }